import React from "react"
import { graphql } from "gatsby"
import CasesPage from "../components/cases/cases-cards"
import { ICaseStudy } from "../components/cases/cases-cards/CaseStudyCard"
import Seo from "../components/Seo"

const Cases = ({ data }: any) => {
  const {
    data: pageData,
    lang,
    first_publication_date,
    last_publication_date,
  } = data.prismicCaseStudiesLandingPage ?? {}

  const pageTitle = pageData?.page_title?.text || ""
  const pageDescription = pageData?.page_description || ""

  const caseStudies: ICaseStudy[] = (pageData?.case_studies || [])
    .map((item: any) => {
      const doc = item.case_study?.document
      if (!doc) return null
      return {
        slug: doc.uid,
        title: doc.data.title?.text || "",
        companyName: doc.data.company_name || "",
        companySector: doc.data.company_sector || "",
        imageUrl: doc.data.hero_image?.url || "",
      }
    })
    .filter(Boolean)

  const body = pageData?.body || []

  return (
    <>
      <Seo
        title={pageData?.meta_title || ""}
        description={pageData?.meta_description || ""}
        slug="cases"
        lang={lang}
        datePublished={first_publication_date}
        dateModified={last_publication_date}
      />
      <CasesPage
        pageTitle={pageTitle}
        pageDescription={pageDescription}
        caseStudies={caseStudies}
        body={body}
      />
    </>
  )
}

export default Cases

export const query = graphql`
  query CasesPageQuery($locale: String!) {
    prismicCaseStudiesLandingPage(lang: { eq: $locale }) {
      lang
      first_publication_date
      last_publication_date
      data {
        meta_title
        meta_description
        page_title {
          text
        }
        page_description
        case_studies {
          case_study {
            document {
              ... on PrismicCaseStudiesTemplate {
                uid
                data {
                  title {
                    text
                  }
                  company_name
                  company_sector
                  hero_image {
                    url
                  }
                }
              }
            }
          }
        }
        body {
          __typename
          ... on PrismicCaseStudiesLandingPageBodyTitledescriptionimage {
            id
            slice_type
            primary {
              subtitle
              title {
                raw
              }
              align
              description1 {
                html
              }
              image_position
              image {
                fluid {
                  aspectRatio
                  base64
                  sizes
                  src
                  srcSet
                  srcSetWebp
                  srcWebp
                }
                alt
              }
            }
          }
          ... on PrismicCaseStudiesLandingPageBodyQuote {
            id
            slice_type
            primary {
              subtitle
              title {
                raw
              }
            }
          }
          ... on PrismicCaseStudiesLandingPageBodyTextdescriptioncolumns {
            id
            slice_type
            primary {
              columns_per_row
            }
            items {
              description1 {
                html
              }
              title {
                raw
              }
            }
          }
          ... on PrismicCaseStudiesLandingPageBodyStackcolumnscontent {
            id
            slice_type
            items {
              description1 {
                html
              }
              title {
                raw
              }
              image {
                alt
                fluid {
                  aspectRatio
                  base64
                  src
                  srcSet
                  srcSetWebp
                  srcWebp
                  sizes
                }
              }
            }
          }
        }
      }
    }
  }
`
